import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BasePage } from '../base-page';
import { SaveCategoryModel } from 'src/app/models/catalog/save-category.model';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoryTreeItemModel } from 'src/app/models/catalog/category-tree-item.model';
import { ImageModel } from 'src/app/models/common/image.model';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-products-sort',
  templateUrl: './products-sort.component.html',
  styleUrl: './products-sort.component.scss',
  standalone: false
})
export class ProductsSortComponent extends BasePage implements OnInit {

  public items: ProductItemSortModel[] = [];

  public get hasInStoreItems() {
    return this.items.filter(x => x.hasInStore == true);
  }

  public get hasNoStoreItems() {
    return this.items.filter(x => x.hasInStore == false);
  }

  public category: SaveCategoryModel;

  public searchLeftText = '';
  public searchRightText = '';


  public constructor(private mApiService: ApiService,
    private mMessageService: MessageService,
    private mChangeDetector: ChangeDetectorRef,
    activatedRoute: ActivatedRoute) {
    super();

    this.category = {
      id: activatedRoute.snapshot.params['id'],
      isPublished: true
    };

    this.isLoading = true;
  }

  public searchLeft() {
    const firstElement = document.querySelector(`[data-name-left*="${this.searchLeftText.toLowerCase()}"]`) as HTMLElement;
    this.toSearchElement(firstElement);
  }

  public searchRight() {
    const firstElement = document.querySelector(`[data-name-right*="${this.searchRightText.toLowerCase()}"]`) as HTMLElement;
    this.toSearchElement(firstElement);
  }

  ngOnInit(): void {

    this.mApiService.get<SaveCategoryModel>(`/api/admin/catalog/category/${this.category.id}`).subscribe({
      next: r => {
        this.category = r;
        this.mApiService.get<ProductItemSortModel[]>(`/api/admin/catalog/category/${this.category.id}/sort`).subscribe({
          next: r => {
            this.items = r;

            for (let i = 0; i < this.items.length; i++) {
              this.items[i].order = i + 1;
            }

            this.isBusy = this.isLoading = false;
          },
          error: () => {
            this.isBusy = this.isLoading = false;
          }
        });
      },
      error: () => this.isLoading = false

    });

  }

  public save() {
    this.isBusy = true;
    this.mApiService.put('/api/admin/catalog/product/sort', this.items).subscribe({
      next: () => {
        this.mMessageService.addMessage({
          type: 'success',
          text: 'Сохранено'
        });
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public drop(hasInStore: boolean, $event: CdkDragDrop<ProductItemSortModel, number, number>) {

    const displayItems = this.items.filter(x => x.hasInStore == hasInStore);

    const currentIndex = this.items.indexOf(displayItems[$event.currentIndex]);
    const previousIndex = this.items.indexOf(displayItems[$event.previousIndex]);

    const swapOrder = this.items[previousIndex].order;
    this.items[previousIndex].order = this.items[currentIndex].order;
    this.items[currentIndex].order = swapOrder;

    // const swap = this.items[previousIndex];
    // const swapOrder = swap.order;

    // swap.order = this.items[currentIndex].order;
    // this.items[currentIndex].order = swapOrder;

    // this.items[previousIndex] = this.items[currentIndex];
    // this.items[currentIndex] = swap;

    moveItemInArray(this.items, previousIndex, currentIndex);

    this.items.forEach((el, index) => el.order = index + 1);
  }

  public setValue(change: ProductItemSortModel, event: any) {

    let newOrder = parseInt(event.target.value);
    if (!(newOrder > 0)) {
      return;
    }

    const maxOrder = Math.max(...this.items.map(i => i.order));

    if (newOrder > maxOrder) {
      newOrder = maxOrder;
    }

    const previewOrder = change.order;

    for (let item of this.items) {
      if (item.order <= newOrder && item.order >= previewOrder) {
        item.order--;
        if (item.order < 1) {
          item.order = 1;
        }
      }
    }

    change.order = newOrder

    // find same order in items
    let hasSameOrder = false;
    for (let item of this.items) {
      if (item.id !== change.id && item.order == change.order) {
        hasSameOrder = true;
        break;
      }
    }

    if (hasSameOrder) {
      for (let item of this.items) {
        if (item.order >= change.order && item.id != change.id) {
          item.order++;
        }
      }
    }

    this.items = this.items.sort((a, b) => a.order - b.order);

    this.items.forEach((x, index) => { x.order = index + 1 });
  }

  private toSearchElement(element: HTMLElement) {
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      element.style.transition = 'background-color 250ms linear';
      element.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';

      setTimeout(() => {
        element.style.backgroundColor = '';
      }, 1200);

    }
  }
}

export interface ProductItemSortModel {
  id: string;
  name: string;
  order: number;
  isPublished: boolean;
  hasInStore: boolean;
}
